import { Container } from "@mui/material"
import { Outlet } from "react-router-dom"
import AppBar from "./AppBar"
import { useRef } from 'react';

export default function PageLayout() {

  const container = useRef();

  return (
    <Container
      maxWidth={false}
      disableGutters
      ref={container}
    // sx={{ pt: appBarHeight + "px" }}
    >
      <AppBar />
      <Outlet />
    </Container>
  )
}
